import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from 'react-router-dom';
import { createRoot } from "react-dom/client";
import { i18nReady } from "./i18n/i18n";
import { startReplay, whenIdle } from "./lib/sentryReplay";
import App from "./App.tsx";
import "./styles/index.css";

const isAdminPage = () => /^\/admin(?:\/|$)/.test(window.location.pathname);
document.documentElement.dataset.trenioAdminDocument = isAdminPage() ? '1' : '0';

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
    integrations: [
        Sentry.reactRouterV7BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
        // Replay is added once the app has rendered (startReplay below), not in the entry bundle
    ],
    beforeSend: event => isAdminPage() ? null : event,
    beforeSendTransaction: event => isAdminPage() ? null : event,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
});

// Render once the detected language is available (immediate for Polish; one small chunk otherwise)
i18nReady.finally(() => {
    createRoot(document.getElementById("root")!).render(
        <Sentry.ErrorBoundary fallback={<p style={{ padding: '2rem' }}>Wystąpił nieoczekiwany błąd. Odśwież stronę.</p>} showDialog>
            <App />
        </Sentry.ErrorBoundary>
    );
    if (!isAdminPage()) whenIdle(() => { void startReplay(); });
});
